// extracted by mini-css-extract-plugin
export default {"outerDiv":"GalleryImgCard_outerDiv__PHYCt","innerDiv":"GalleryImgCard_innerDiv__L4VoP","img":"GalleryImgCard_img__8qDvW"};